import { Injectable }       from '@angular/core';

import { PreguntaBase }     from '../_models/preguntabase.model';

import { TextboxPregunta }  from '../_models/preguntabase-textbox.model';
import { DropdownPregunta } from '../_models/preguntabase-dropdown.model';
import { DropdownExtendedPregunta } from '../_models/preguntabase-dropdownextended.model';

@Injectable()
export class PreguntasService {
  // Todo: get from a remote source of question metadata
  // Todo: make asynchronous
  getQuestions() {

    let questions: PreguntaBase<any>[] = [

      new DropdownPregunta({
        key: 'campo-de-select',
        label: 'Campo de select',
        value: 'opcion2',
        options: [
          {key: 'opcion1',  value: 'Opcion 1'},
          {key: 'opcion2',  value: 'Opcion 2'},
          {key: 'opcion3',   value: 'Opcion 3'},
          {key: 'opcion4', value: 'Opcion 4'},
          {key: 'anadir-nuevo', value: 'Añadir uno nuevo'}
        ],
        order: 3
      }),

      new DropdownPregunta({
        key: 'campo-de-select2',
        label: 'Campo de select2',
        value: 'opcion3',
        options: [
          {key: 'opcion1',  value: 'Opcion 1'},
          {key: 'opcion2',  value: 'Opcion 2'},
          {key: 'opcion3',   value: 'Opcion 3'},
          {key: 'opcion4', value: 'Opcion 4'}
        ],
        order: 3
      }),

      /*new DropdownExtendedPregunta({
        key: 'campo-de-select-extendido',
        label: 'Campo de select extendido',
        value: 'opcion2',
        options: [
          {key: 'opcion3',   value: 'Opcion 3'},
          {key: 'opcion5', value: 'Opcion 4'}
        ],
        order: 4
      }),*/

      new TextboxPregunta({
        key: 'nombre',
        label: 'Nombre',
        required: true,
        order: 1
      }),

      new TextboxPregunta({
        key: 'email',
        label: 'Email',
        type: 'email',
        order: 2
      })

    ];

    return questions.sort((a, b) => a.order - b.order);
  }

}



// WEBPACK FOOTER //
// ./src/app/_services/preguntas.service.ts